<template lang="pug">
.map-offcanvas__item
  //- Header
  .map-offcanvas__title
    span(uk-icon="icon: location; ratio: .7")
    div &nbsp;災害情報

  //- Body
  .map-offcanvas__body(v-if="custom_layers_list")
    .uk-padding-small.uk-padding-remove-vertical
      ul.uk-list.uk-margin-remove(uk-accordion)
        li(v-for="custom_layers, area_name in custom_layers_list", :key="`area_${area_name}`")
          a.uk-accordion-title(href="#")
            .uk-flex.uk-flex-middle
              span {{ area_name }}&nbsp;
              span.uk-badge {{ custom_layers.length }}
          .uk-accordion-content
            ul.uk-list.uk-list-square
              li(v-for="custom_layer in custom_layers", :key="`custom_layer_${custom_layer.props.id}`")
                a(href="#", @click.prevent="handlePopup(custom_layer)") {{ custom_layer.props.name }}

  //- Else
  .map-offcanvas__body(v-else) 現在公開中の情報はありません。
</template>

<script>
import * as types from "../js/mutations/map-mutations"

export default {
  computed: {
    custom_layers_list () { return this.$store.getters.custom_layers_list },
  },
  methods: {
    handlePopup (layer) {
      this.$store.dispatch(types.TOGGLE_LAYER, {layer_name: 'custom_layers', state: true})
      this.$store.dispatch(types.POPUP, layer)
    },
  }
}
</script>

